import {
  ARTICLE_TYPE, CODE_REGEX, CONSUMER_VEHICLE_TYPES, ENTITY_NAME_REGEX,
  NUMBER_TYPE_ERROR_MSG, TELEMATICS_TYPES,
  VEHICLE_CATEGORY, VEHICLE_NUMBER_REGEX, VEHICLE_TYPE
} from 'src/utils/constants';
import { getMaxLengthErrorMsg, getMaxLimitErrorMsg } from 'src/utils/getInitials';
import * as Yup from 'yup';

const FLEET_SERVICE_PROVIDER_TYPES = [
  { id: 'WAILON', name: 'WAILON' },
  { id: 'OMNICOMM', name: 'OMNICOMM' },
  { id: 'LOCONAV', name: 'LOCONAV' },
  { id: 'GEOSAFE', name: 'GEOSAFE' },
  { id: 'VAMOSYS', name: 'VAMOSYS' }
];

const VEHICLE_TYPE_FORM_OPTIONS = VEHICLE_TYPE.filter(
  (option) => option.id !== 'Semi Movable'
);

// vehicle form model
export const vehicleFormModel = {
  formId: 'vehicleConfig',
  formField: {
    vehicleGroup: {
      name: 'group',
      label: 'Vehicle Group',
      requiredErrorMsg: 'Vehicle Group is required',
      type: 'select',
      data: []
    },
    site: {
      name: 'site',
      label: 'Select Site',
      requiredErrorMsg: 'Site is required',
      type: 'select',
      data: []
    },
    department: {
      name: 'department',
      label: 'Select Department',
      requiredErrorMsg: 'Department is required',
      type: 'select',
      data: []
    },
    contractor: {
      name: 'contractor',
      label: 'Select Contractor',
      type: 'select',
      data: []
    },
    vehicleCategory: {
      name: 'category',
      label: 'Vehicle Category',
      requiredErrorMsg: 'Vehicle Category is required',
      type: 'select',
      data: VEHICLE_CATEGORY
    },
    transferTank: {
      name: 'tank',
      label: 'Select Transfer Tank',
      requiredErrorMsg: 'Tank selection is required',
      type: 'select',
      data: []
    },
    registrationNum: {
      name: 'registration_num',
      label: 'Registration Number',
      requiredErrorMsg: 'Registration Number is required',
      invalidErrorMsg: 'Registration Number is Invalid',
      type: 'text',
    },
    vehicleType: {
      name: 'type',
      label: 'Vehicle Type',
      requiredErrorMsg: 'Vehicle Type is required',
      type: 'select',
      data: VEHICLE_TYPE_FORM_OPTIONS
    },
    assetCode: {
      name: 'asset_code',
      label: 'Asset Code',
      requiredErrorMsg: 'Asset Code is required',
      invalidErrorMsg: 'Asset Code is invalid',
      type: 'text',
    },
    assetType: {
      name: 'consumer_vehicle',
      label: 'Asset Type',
      requiredErrorMsg: 'Asset Type is required',
      type: 'select',
      data: CONSUMER_VEHICLE_TYPES
    },
    tankCapacity: {
      name: 'tank_capacity',
      label: 'Tank Capacity',
      requiredErrorMsg: 'Tank Capacity is required',
      type: 'text',
    },
    telemeticsEnabled: {
      name: 'telemetics_enabled',
      label: 'Telematics Enabled',
      requiredErrorMsg: 'Telematics Enabled is required',
      type: 'switch',
    },
    telemeticsCategory: {
      name: 'telemetics_category',
      label: 'Telemetics Category',
      requiredErrorMsg: 'Telemetics Category is required',
      type: 'select',
      data: TELEMATICS_TYPES,
    },
    fleetServiceProvider: {
      name: 'fleet_service_provider',
      label: 'Fleet Service Provider',
      type: 'select',
      data: FLEET_SERVICE_PROVIDER_TYPES,
    },
    showOmnicommLogIgnition: {
      name: 'show_omnicomm_log_ignition',
      label: 'Ignition',
      type: 'switch',
    },
    showOmnicommLogEngine: {
      name: 'show_omnicomm_log_engine',
      label: 'Engine',
      type: 'switch',
    },
    showOmnicommLogSecondaryEngine: {
      name: 'show_omnicomm_log_secondary_engine',
      label: 'Secondary Engine',
      type: 'switch',
    },
    omnicommSecondaryEngineThreshold: {
      name: 'omnicomm_secondary_engine_threshold',
      label: 'Secondary Engine Threshold',
      type: 'text',
    },
    serviceInterval: {
      name: 'service_interval',
      label: 'Service Interval',
      requiredErrorMsg: 'Service Interval is required',
      type: 'date',
    },
    vehicleModel: {
      name: 'model',
      label: 'Vehicle Model',
      invalidErrorMsg: 'Invalid Vehicle Model name',
      type: 'text',
    },
    fuelType: {
      name: 'fuel_type',
      label: 'Fuel Type',
      requiredErrorMsg: 'Fuel Type is required',
      type: 'select',
      data: ARTICLE_TYPE
    },
    maxDiffAllowed: {
      name: 'max_diff_allowed',
      label: 'Max Diff Allowed',
      requiredErrorMsg: 'Max Diff Allowed is required',
      type: 'text',
    },
    odometerReading: {
      name: 'odometer_reading',
      label: 'Odometer Reading',
      requiredErrorMsg: 'Odometer Reading is required',
      type: 'text',
    },
    monthlyFixedEngineHours: {
      name: 'monthly_fixed_engine_hours',
      label: 'Monthly Fixed Engine Hours',
      requiredErrorMsg: 'Fixed Engine Hours is required',
      type: 'text',
    },
    standardMileage: {
      name: 'standard_mileage',
      label: 'Standard Mileage',
      type: 'text',
    },
    poNumber: {
      name: 'po_number',
      label: 'PO Number',
      type: 'text',
    },
    tyreManagementEnabled: {
      name: 'tyre_management_enabled',
      label: 'Enable Tyre Management for this vehicle',
      type: 'checkbox',
    },
  }
};

// Initial values
const {
  formField: {
    vehicleGroup,
    site,
    department,
    contractor,
    vehicleCategory,
    transferTank,
    registrationNum,
    vehicleType,
    assetCode,
    assetType,
    tankCapacity,
    telemeticsEnabled,
    telemeticsCategory,
    fleetServiceProvider,
    showOmnicommLogIgnition,
    showOmnicommLogEngine,
    showOmnicommLogSecondaryEngine,
    omnicommSecondaryEngineThreshold,
    serviceInterval,
    vehicleModel,
    fuelType,
    maxDiffAllowed,
    odometerReading,
    monthlyFixedEngineHours,
    standardMileage,
    poNumber,
    tyreManagementEnabled
  }
} = vehicleFormModel;

export const vehicleFormInitialValues = {
  [vehicleGroup.name]: '',
  [site.name]: '',
  [department.name]: '',
  [contractor.name]: '',
  [vehicleCategory.name]: '',
  [transferTank.name]: '',
  [registrationNum.name]: '',
  [vehicleType.name]: '',
  [assetCode.name]: '',
  [assetType.name]: '',
  [tankCapacity.name]: '',
  [telemeticsEnabled.name]: false,
  [telemeticsCategory.name]: '',
  [fleetServiceProvider.name]: '',
  [showOmnicommLogIgnition.name]: true,
  [showOmnicommLogEngine.name]: true,
  [showOmnicommLogSecondaryEngine.name]: false,
  [omnicommSecondaryEngineThreshold.name]: 8,
  [serviceInterval.name]: 0,
  [vehicleModel.name]: '',
  [fuelType.name]: '',
  [maxDiffAllowed.name]: 0,
  [monthlyFixedEngineHours.name]: 0,
  [odometerReading.name]: '',
  [standardMileage.name]: '',
  [poNumber.name]: '',
  [tyreManagementEnabled.name]: false,
};

// validation schema
const getAssetCodeValidationSchema = ({ assetCodeMappingEnabled, isEdit }) => {
  if (assetCodeMappingEnabled && !isEdit) {
    return Yup.string()
      .matches(/^\d{3,4}$/, 'Asset Code must be exactly 3 or 4 digits')
      .required(assetCode.requiredErrorMsg);
  }

  return Yup.string()
    .matches(CODE_REGEX, assetCode.invalidErrorMsg)
    .required(assetCode.requiredErrorMsg);
};

export const getVehicleValidationSchema = ({
  assetCodeMappingEnabled = false,
  isEdit = false,
} = {}) => Yup.object().shape({
  [site.name]: Yup.string().required(`${site.requiredErrorMsg}`),
  [registrationNum.name]: Yup.string().max(50, getMaxLengthErrorMsg(registrationNum, 50)).matches(VEHICLE_NUMBER_REGEX, registrationNum.invalidErrorMsg)
    .required(registrationNum.requiredErrorMsg),
  [assetCode.name]: getAssetCodeValidationSchema({ assetCodeMappingEnabled, isEdit }),
  [vehicleType.name]: Yup.string().required(vehicleType.requiredErrorMsg),
  [tankCapacity.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(99999, getMaxLimitErrorMsg(tankCapacity, 99999))
    .required(tankCapacity.requiredErrorMsg),
  [fuelType.name]: Yup.string().required(fuelType.requiredErrorMsg),
  [odometerReading.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(999999, getMaxLimitErrorMsg(odometerReading, 999999))
    .required(odometerReading.requiredErrorMsg),
  [maxDiffAllowed.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(999, getMaxLimitErrorMsg(maxDiffAllowed, 999)),
  [serviceInterval.name]: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? 0 : value))
    .typeError(NUMBER_TYPE_ERROR_MSG)
    .max(99999, getMaxLimitErrorMsg(serviceInterval, 99999)),
  [omnicommSecondaryEngineThreshold.name]: Yup.number()
    .typeError(NUMBER_TYPE_ERROR_MSG)
    .min(0, 'Secondary Engine Threshold cannot be negative')
    .max(99999, getMaxLimitErrorMsg(omnicommSecondaryEngineThreshold, 99999)),
  [vehicleModel.name]: Yup.string()
    .nullable()
    .max(100, getMaxLengthErrorMsg(vehicleModel, 100))
    .test('vehicle-model-format', vehicleModel.invalidErrorMsg, (value) => (
      !value || ENTITY_NAME_REGEX.test(value)
    )),
  [poNumber.name]: Yup.string().max(50, getMaxLengthErrorMsg(poNumber, 50)).nullable(),
  [standardMileage.name]: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError(NUMBER_TYPE_ERROR_MSG)
    .moreThan(0, 'Standard Mileage must be greater than 0')
    .max(99999, getMaxLimitErrorMsg(standardMileage, 99999))
    .notRequired(),
  [telemeticsCategory.name]: Yup
    .string()
    .when(telemeticsEnabled.name, {
      is: true,
      then: Yup.string().required(telemeticsCategory.requiredErrorMsg),
      otherwise: Yup.string().notRequired(),
    }),
  [transferTank.name]: Yup
    .string()
    .nullable()
    .when(vehicleCategory.name, (category, schema) => {
      if (category === 'TRNSFR') {
        return schema.required(transferTank.requiredErrorMsg);
      }
      return schema;
    }),
  [monthlyFixedEngineHours.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(99999, getMaxLimitErrorMsg(maxDiffAllowed, 99999)),
});
